import createIcon from '../../createIcon';

/**
 * @component @name LaptopMac
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTguNUMyMS4xIDE4LjUgMjEuOTkgMTcuNiAyMS45OSAxNi41TDIyIDUuNUMyMiA0LjQgMjEuMSAzLjUgMjAgMy41SDRDMi45IDMuNSAyIDQuNCAyIDUuNVYxNi41QzIgMTcuNiAyLjkgMTguNSA0IDE4LjVIMEMwIDE5LjYgMC45IDIwLjUgMiAyMC41SDIyQzIzLjEgMjAuNSAyNCAxOS42IDI0IDE4LjVIMjBaTTQgNS41SDIwVjE2LjVINFY1LjVaTTEyIDE5LjVDMTEuNDUgMTkuNSAxMSAxOS4wNSAxMSAxOC41QzExIDE3Ljk1IDExLjQ1IDE3LjUgMTIgMTcuNUMxMi41NSAxNy41IDEzIDE3Ljk1IDEzIDE4LjVDMTMgMTkuMDUgMTIuNTUgMTkuNSAxMiAxOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LaptopMac = createIcon('LaptopMac', [
  [
    'path',
    {
      d: 'M20 18.5C21.1 18.5 21.99 17.6 21.99 16.5L22 5.5C22 4.4 21.1 3.5 20 3.5H4C2.9 3.5 2 4.4 2 5.5V16.5C2 17.6 2.9 18.5 4 18.5H0C0 19.6 0.9 20.5 2 20.5H22C23.1 20.5 24 19.6 24 18.5H20ZM4 5.5H20V16.5H4V5.5ZM12 19.5C11.45 19.5 11 19.05 11 18.5C11 17.95 11.45 17.5 12 17.5C12.55 17.5 13 17.95 13 18.5C13 19.05 12.55 19.5 12 19.5Z',
      key: '12o2qs',
    },
  ],
]);

export default LaptopMac;
